import { Nil } from "./types";
export const stringUtils = {
  convertSnakeToCamelCase(str: string) {
    return str
      .toLowerCase()
      .replace(/[-_][a-z0-9]/g, (group) => group.slice(-1).toUpperCase());
  },
  convertSnakeToTitleCase(str: string) {
    return str
      .replaceAll("_", " ")
      .replaceAll(/  +/g, " ")
      .trim()
      .split(" ")
      .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
      .join(" ");
  },
};

/**
 * Joins strings with spaces. Removes empty strings
 * @param vals
 * @returns string
 */
export function joinStrings(...vals: (string | Nil)[]) {
  return vals
    .filter(Boolean)
    .map((x) => (x || "").trim())
    .join(" ");
}
